import { GraphQLClient } from "graphql-request";
import Queries from "./graphql/queries";
//import { mergeDeepRight, path } from 'ramda'

function getResidentialTemplates(payload) {
  return new GraphQLClient("/api/graphql")
    .request(Queries.ResidentialTemplates, payload)
    .then((data) => data);
}
function getResidentialTemplate(payload) {
  return new GraphQLClient("/api/graphql")
    .request(Queries.ResidentialTemplate, payload)
    .then((data) => data);
}

export { getResidentialTemplates, getResidentialTemplate };
